// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bgv_a bhl_ea bhl_a","LoadingSwitch__init":"bgv_b bhl_a bhl_w bhl_j bhl_ul bhl_um bhl_fm"};